export default __webpack_public_path__ + "static/wotfard-medium-webfont-b1cca1e6a207d688b19ecb61607da827.woff2";